import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SharedRoutesService} from "../_services/shared-routes.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ToastController} from "@ionic/angular";

@Injectable()
export abstract class DefaultComponent implements OnDestroy {
    // internal unSubscriber for observables
    public ngUnsubscribe: Subject<any> = new Subject();
    rights: any = {};
    exception: any = [];

    protected constructor(
        protected router: Router,
        protected activatedRoute: ActivatedRoute,
        protected sharedRoutesService: SharedRoutesService,
        protected toastController: ToastController

    ) {
        this.getRouteRights();
    }


    getRouteRights(): any {
        const queryParams = {
            route: this.router.url
        };

        return this.sharedRoutesService
            .list(queryParams)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (data:any) => {
                    if (data.crud == '0000') {
                       // console.log('data',data.crud);
                       // this.router.navigate(['/private/dashboard']);
                    } else {
                        this.rights.create = data.crud.charAt(0);
                        this.rights.read = data.crud.charAt(1);
                        this.rights.update = data.crud.charAt(2);
                        this.rights.delete = data.crud.charAt(3);
                    }

                }
            );
    }

    async presentErrorToast(message: string) {
        const toast = await this.toastController.create({
            message,
            duration: 3000,
            position: 'bottom',
            color: 'dark', // black theme
            cssClass: 'custom-toast'
        });
        toast.present();
    }



    ngOnDestroy() {
        // unsubscribe from all the observables
        this.ngUnsubscribe.next(undefined);
        this.ngUnsubscribe.complete();
    }







}
